module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division II15.f49b121e.png";